import { useQuery } from '@tanstack/react-query'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

const useExternal = (categoryId) => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()

  const getExternal = async (categoryId) => {
    const url = encodeURI(
      `${env.apiUrl}/categories/${categoryId}/externalModules`
    )
    const response = await securedFetch(url)
    await handleResponse(response)
    return response.json()
  }

  const query = useQuery({
    queryKey: ['external', categoryId],
    queryFn: () => getExternal(categoryId),
    enabled: !!categoryId,
    refetchOnWindowFocus: false
  })

  query.isError && handleError(query.error, 'Error getting external')

  return {
    external: query.data
  }
}

export { useExternal }
